import { Component } from '@angular/core'
import { AuthService } from '../../auth/auth.service'
import { ObservableCacheService } from '../../services/observable-cache.service'

@Component({
    selector: 'app-site-expired-session',
    templateUrl: './site-expired-session.component.html',
    styleUrls: ['./site-expired-session.component.scss'],
    standalone: false,
})
export class SiteExpiredSessionComponent {
    constructor(
        private authService: AuthService,
        private cacheService: ObservableCacheService
    ) {}

    public loginPage() {
        // Clear cached data for current user before logging out
        this.cacheService.clearCurrentUserCache()
        this.authService.logoffAndRevokeTokensLocal()
    }
}
